// Fades in any element with the "sz-reveal" class as it scrolls into view.
export default {
  mounted() {
    if (typeof IntersectionObserver === "undefined") {
      this.$el.querySelectorAll(".sz-reveal").forEach((el) => el.classList.add("is-in"));
      return;
    }
    this._revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            this._revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    this.$nextTick(() => {
      this.$el.querySelectorAll(".sz-reveal").forEach((el) => this._revealObserver.observe(el));
    });
  },
  beforeDestroy() {
    if (this._revealObserver) this._revealObserver.disconnect();
  },
};